<header>
  <div class="container">
      <div class="row">
          <div class="col-md-4 col-xs-3" id="logo"><a href="index.html">Universidad Nacional de Tucumán</a></div>
          <!--<div class="btn-responsive-menu"> <span class="bar"></span> <span class="bar"></span> <span class="bar"></span> </div>
           <nav class="col-md-8 col-xs-9" id="top-nav">
               <ul>
                      <li><a href="../index.html">Menú 1</a></li>
                      <li><a href="../index.html">Menú 2</a></li>
                      <li><a href="../index.html" id="purchase">Menú 3</a></li>
                 </ul>
          </nav> -->
      </div><!-- End row -->
  </div><!-- End container -->
</header>

<ng-content class="inner-body"></ng-content>

<footer>
  <section class="container">
      <div class="row">
          <div class="col-md-5">
              <h3>Sobre Nosotros</h3>
              <p>Lorem ipsum dolor sit amet, duo iudico accusamus ne, at vix sumo alia. Usu etiam probatus ne, eu magna ullum iusto his. Nec ea case eirmod dissentiunt. Etiam denique has cu, nam quando accusamus dissentiunt ne. Ea sit malorum scribentur.</p>
          </div>
          <div class="col-md-5" id="contact">
              <h3>Contactanos</h3>
              <p>Nec ea case eirmod dissentiunt. Etiam denique has cu, nam quando accusamus dissentiunt ne. </p>
              <ul>
                  <li><i class="icon-home"></i> Ayacucho 491 - (T4000INI) </li>
                  <li><i class="icon-phone"></i> Tel. +54 381 4247752 </li>
                  <li><i class="icon-envelope"></i> Email: <a href="#">infount.com </a></li>
                  <!-- <li><i class="icon-skype"></i> Skype name: Annova</li> -->
              </ul>
          </div>
      </div><!-- end row -->
  </section>
  <section id="footer_2">
      <div class="container">
          <div class="row">
              <div class="col-md-6">
                  <ul id="footer-nav">
                      <li>Copyright© UNT - Universidad Nacional de Tucumán </li>
                      <li><a href="#">Terminos de Uso</a></li>
                      <li><a href="#">Privacidad</a></li>
                  </ul>
              </div>
              <div class="col-md-6">
                  <ul class="social-bookmarks clearfix">
                      <li class="facebook"><a href="#">facebook</a></li>
                      <li class="googleplus"><a href="#">googleplus</a></li>
                      <li class="twitter"><a href="#">twitter</a></li>
                      <li class="delicious"><a href="#">delicious</a></li>
                      <li class="paypal"><a href="#">paypal</a></li>
                  </ul>
              </div>
          </div>
      </div>
  </section>
</footer>
<div id="toTop" style="display: block;">Volver</div>